import React from 'react';
import Nav from './Nav';
import SocialFooter from "./SocialFooter";
import Typography from "../styles/Typography";
import GlobalStyles from "../styles/GlobalStyles";

const Layout = ({ children }) => {
  return <>
    <GlobalStyles/>
    <Typography/>
    <Nav/>
    {children}
    <SocialFooter/>
  </>
}

export default Layout